import React from "react";
import {Table, Button} from "reactstrap";
import {useSelector, useDispatch } from 'react-redux';
import {globals} from "../Globals/Globals"
import NestedTitlePicture3 from "../NestedTitlePicture3/NestedTitlePicture3";
import { openModalToolbox } from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {deleteToolboxPartners, revertStatusToolboxPartners} from "../../redux/toolboxPartnerSlice"

const ToolboxPartnersRawTableDataSync = (props) => {
    const dispatch = useDispatch();
    const {deleteToolboxPartners_result} = useSelector((state) => state.toolbox)
    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteToolboxPartners_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Partenaire toolbox supprimé"}));
            }
            finally{
                dispatch(revertStatusToolboxPartners())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.toolboxPartners_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            console.error(`handleManager for ${p_callback_handler} raise error ${error.message}`)
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }

    /**
     * tableRendering
     */
    const tableRendering = () => {
        let table_body = null;

        if (!((props.toolboxPartners_list != null) && (props.toolboxPartners_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucun partenaire Toolbox</td></tr>;
        }
        else{
            table_body = props.toolboxPartners_list.map((toolboxPartnersItem,i)=>{
                return  <tr key={toolboxPartnersItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                <NestedTitlePicture3
                                    title = {toolboxPartnersItem.data_blob.data_tier.partner}
                                    pictureURL = {toolboxPartnersItem.data_blob.data_tier.image}
                                    text = {`Categorie : <i>${toolboxPartnersItem.data_blob.data_tier.category}</i>`}
                                    height = {"400px"}
                                    width = {"100%"}
                                    center = {true}
                                    color = {"black"}
                                    font_size = {"larger"}
                                />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(toolboxPartnersItem.data_guid, (toolboxPartnersObject)=>{
                                                                                            dispatch(openModal(
                                                                                                {title:`Supprimer le partenaire ${toolboxPartnersObject.data_blob.data_tier.partner} ?`,
                                                                                                 okCallBack:(DialogObject)=>{dispatch(deleteToolboxPartners(toolboxPartnersObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(toolboxPartnersItem.data_guid, (toolboxPartnersObject)=>{dispatch(openModalToolbox({toolboxPartners_data_guid:toolboxPartnersObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

export default ToolboxPartnersRawTableDataSync;
